import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
    selector: '[sablon]',
    standalone: true,
})
export class SablonDirective {
    /** Unique name for query input type. */
    @Input()
    get sablonTipi(): string | any { return this.#__tipi; }
    set sablonTipi(value: string) {
        // If the directive is set without a type (updated programatically), then this setter will
        // trigger with an empty string and should not overwrite the programatically set value.
        if (!value) { return; }
        this.#__tipi = value;
    }
    #__tipi: string | any;

    constructor(public template: TemplateRef<any>) { }
}